import { axiosInstance } from '.';

const getCurranciesList = async (params) => await axiosInstance.get('/currencies', { params });

const getSpecialtiesListLookup = async (params) => await axiosInstance.get("/branch_specialties",{params})

const getBranchesList = async (params) => await axiosInstance.get('/branches', { params });

const getProvidersList = async (params) => await axiosInstance.get('/service_providers', { params });

const getServicesListLookUp = async (params) => await axiosInstance.get('/services', { params });

export { getCurranciesList,
         getSpecialtiesListLookup,
         getBranchesList,
         getProvidersList,
         getServicesListLookUp };
